/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UndoInputs */

const en_undo = /** @type {(inputs: UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {UndoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const undo = /** @type {((inputs?: UndoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UndoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_undo(inputs)
});